import { apiURL } from "./api/client"
import { setAuthToken } from "./api/calls"
import { isApiBaseUrl } from "./util"
import store from '../store'

export function oauthLogin(provider="google", signup=false){
  doPopup(apiURL+'auth/'+provider, async function(loginToken){
    setAuthToken(loginToken);
    if (signup) {
      await store.dispatch('loadMe');
      await store.dispatch('users/hubspotNewUser');
    }
    location.reload();
    if(window.afterCompleteSignUpModal){
      store.dispatch('accounts/loadOwned')
      store.dispatch('loadMe');
      window.afterCompleteSignUpModal();
    } else {
      location.reload();
    }
  });
}

export function doPopup(url, onCallback){
  window.open(url);

  window.addEventListener('message', function(event){
    if (isApiBaseUrl(event.origin)) {
      onCallback(event.data);
    }
  }, false);
}



// WEBPACK FOOTER //
// ./src/lib/oauth.js